import { useState } from 'react';
import { FileWithPath } from 'react-dropzone';

const MAX_FILE_SIZE = 15728640; // 15MB

export const useFileUpload = () => {
    const [files, setFiles] = useState<FileWithPath[]>([]);

    const onDrop = (acceptedFiles: FileWithPath[]) => {
        const newFiles = acceptedFiles.filter(acceptedFile => {
            return !files.find(file => file.lastModified === acceptedFile.lastModified && file.name === acceptedFile.name);
        });

        const totalFilesSize = newFiles.reduce((acc, file) => acc + file.size, 0);
        if (totalFilesSize > MAX_FILE_SIZE) {
            return;
        }

        if (newFiles.length >= 0) {
            const updatedFiles = files.concat(newFiles);
            setFiles(updatedFiles);
        }
    };

    const removeFile = (fileName: string) => {
        const updatedFiles = files.filter(file => file.name !== fileName);
        setFiles(updatedFiles);
    };

    const clearFiles = () => {
        setFiles([]);
    };

    return {
        files,
        onDrop,
        removeFile,
        clearFiles,
        maxFileSize: MAX_FILE_SIZE,
    };
};
